module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0405-6b506f5ee150d054cd6840995f44803d.jpg";